import { render, staticRenderFns } from "./TotpMethodInstructions.vue?vue&type=template&id=015085e9&scoped=true"
import script from "./TotpMethodInstructions.vue?vue&type=script&lang=js"
export * from "./TotpMethodInstructions.vue?vue&type=script&lang=js"
import style0 from "./TotpMethodInstructions.vue?vue&type=style&index=0&id=015085e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015085e9",
  null
  
)

export default component.exports